import { createEntityReducer } from "@selas/state-management";

import Endpoint from "../../services/api/endpoint";
import { ICoach } from "../../utils/types/models";

export default createEntityReducer<ICoach>(Endpoint.Coaches, Endpoint.CoachesList);
